<template>
    <div class="footer">
        <div class="contentBox">
            <div class="info_boxs">
                <div class="infos">
                    <img src="../../assets/img/images/footericon1.png" alt="" />
                    <div>{{footerInfo.bottomContent}}</div>
                </div>
                <div class="infos">
                    <img src="../../assets/img/images/footericon2.png" alt="" />
                    <div>{{footerInfo.note}}</div>
                </div>
                <div class="infos">
                    <img src="../../assets/img/images/footericon3.png" alt="" />
                    <div>{{footerInfo.backup}}</div>
                </div>
                <div class="infos">
                    <img src="../../assets/img/images/footericon4.png" alt="" />
                    <div>{{footerInfo.backup1}}</div>
                </div>
            </div>
            <div class="erWeiMa_boxs" v-if="this.languageType == 1">
                <div class="infos_erWeiMa">
                    <img src="../../assets/img/images/footerErWeiMa_h2.png" alt="" />
                    <div>氢能公众号</div>
                </div>
                <div class="infos_erWeiMa">
                    <img src="../../assets/img/images/footerErWeiMa_charge.png" alt="" />
                    <div>充电公众号</div>
                </div>
            </div>
        </div>
        <div class="footer_tips">
            <p class="copyright">版权归北京普发动力控股股份有限公司所有</p>
            <p class="recordNo"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案序号：京ICP备13039200号</a></p>
        </div>
    </div>
</template>

<script>
import { gwGetBottomInfo } from '@/api/index';
export default {
    data() {
        return {
            languageType: '1',
            footerInfo:{}
        };
    },
    created() {
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        this.gwGetBottomInfo();
        window.addEventListener('setItem', () => {
            this.languageType = sessionStorage.getItem('languageType');
            this.gwGetBottomInfo();
        });
    },
    methods: {
        gwGetBottomInfo() {
            let params = {
                language: this.languageType
            };
            gwGetBottomInfo(params).then(res => {
                this.footerInfo = res.obj;
            });
        }
    }
};
</script>
<style scoped lang="less">
@deep: ~'>>>';
.footer {
    width: 100%;
    background-size: 100% 100%;
}
.contentBox {
    display: flex;
    background-color: #023e7a;
    padding: .1875rem 10% .0625rem 10%;
    box-sizing: border-box;
}
.info_boxs {
    width: 80%;
}
.contentBox .title {
    color: #fff;
    font-size: .3rem;
    font-family: monospace;
    margin-bottom: .125rem;
    margin-top: .15rem;
}
.contentBox .infos {
    color: #d6d6d6;
    display: flex;
    font-size: .2rem;
    font-family: monospace;
    padding: .075rem 0 .075rem 0px;
    box-sizing: border-box;
    align-items: center;
}
.contentBox .infos:nth-child(1) img {
    width: .325rem;
    height: .325rem;
    margin-right: .225rem;
    padding-left: .0375rem;
    box-sizing: border-box;
}
.contentBox .infos:nth-child(2) img {
    width: .325rem;
    height: .325rem;
    margin-right: .225rem;
    padding-left: .0125rem;
    box-sizing: border-box;
}
.contentBox .infos:nth-child(3) img {
    width: .325rem;
    height: .325rem;
    margin-right: .225rem;
    padding-left: .025rem;
    box-sizing: border-box;
}
.contentBox .infos:nth-child(4) img {
    width: .325rem;
    height: .325rem;
    margin-right: .225rem;
}
.erWeiMa_boxs {
    display: flex;
    align-items: center;
    color: #fff;
}
.infos_erWeiMa {
    text-align: center;
    font-size: .225rem;
}
.infos_erWeiMa img {
    width: 1.5rem;
    height: 1.5rem;
    margin-bottom: .05rem;
}
.infos_erWeiMa:nth-child(2) {
    margin-left: .25rem;
}
.footer_tips {
    display: flex;
    justify-content: center;
    font-size: .175rem;
    background-color: #023e7a;
    color: #d6d6d6;
    padding: .1rem 0;
}
.copyright {
    margin-right: .1875rem;
}
.recordNo a {
    color: #d6d6d6;
}
.recordNo a:hover {
    color: #409eff;
}
</style>
